import React from 'react';
import {usePersistentStore} from 'stores';
import {Button} from 'components';
import {useMe} from 'hooks';

interface IBannerImpersonateProps {}

const BannerImpersonate = ({}: IBannerImpersonateProps) => {
  const me = useMe();
  const reset = usePersistentStore(s => s.reset);
  return (
    <div className="fixed bottom-15 sm:bottom-5 left-0 right-0 z-50 px-3 flex justify-center">
      <div className="bg-red-700 p-3 flex items-center justify-between gap-3 rounded-md w-full sm:w-auto">
        <p className="text-white text-sm">Impersonating {me?.name ?? ''}</p>
        <Button text="Quit" size="extra-small" onClick={reset} />
      </div>
    </div>
  );
};

export default React.memo(BannerImpersonate);
